module.exports = __webpack_public_path__ + "img/size_3.699da47b.png";